var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3 mx-4"},[(_vm.isVisible)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('h6',[_vm._v(_vm._s(_vm.titleText))]),_c('p',[_vm._v(_vm._s(_vm.actionText))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }